import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Star, Quote } from "lucide-react";

const FALLBACK = [
  { id: "t1", name: "Camila Rojas", role: "Coordinadora de eventos · Corferias", comment: "Movilizamos 3 buses para un congreso de 120 personas y todo salió perfecto. Puntualidad total.", rating: 5 },
  { id: "t2", name: "Andrés Bermúdez", role: "Familia Bermúdez", comment: "Nos llevaron a Villa de Leyva un fin de semana. Conductor impecable y van súper cómoda.", rating: 5 },
  { id: "t3", name: "María Fernanda", role: "Turismo receptivo", comment: "Trabajamos con Líneas Doradas para todos nuestros grupos internacionales. Cero quejas.", rating: 5 },
  { id: "t4", name: "Jorge Ortiz", role: "Empresa Ecopetrol", comment: "Traslados corporativos ejecutivos, tarjeta de crédito empresarial aceptada. Recomendados.", rating: 5 },
];

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([])); }, []);
  const list = Array.isArray(items) && items.length ? items : FALLBACK;

  return (
    <section id="testimonios" data-testid="testimonials-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="orb-gold w-[420px] h-[420px] left-[-140px] top-[100px] opacity-40" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="mb-14 max-w-2xl">
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Testimonios</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight text-[#F5EFE0]">
            Lo que dicen <span className="italic text-gold-grad">quienes ya viajaron</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {list.map((t, i) => (
            <figure key={t.id} data-testid={`testimonial-${i}`} className="card-lux p-6 flex flex-col">
              <Quote size={22} className="text-[#D4AF37]/60 mb-3" />
              <blockquote className="text-[#F5EFE0]/85 text-sm leading-relaxed flex-1 italic font-display text-[17px]">
                "{t.comment}"
              </blockquote>
              <div className="flex items-center gap-1 mt-4">
                {[0,1,2,3,4].map((k) => (
                  <Star key={k} size={13} className={k < t.rating ? "star-on fill-current" : "star-off"} />
                ))}
              </div>
              <figcaption className="flex items-center gap-3 mt-4 pt-4 border-t border-[#3A3229]">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#A5842B] flex items-center justify-center text-[#0A0908] font-display text-lg overflow-hidden">
                  {t.photo_path ? (
                    <img src={fileUrl(t.photo_path)} alt={t.name} className="w-full h-full object-cover" />
                  ) : t.name?.[0]}
                </div>
                <div>
                  <div className="text-sm text-[#F5EFE0] font-medium">{t.name}</div>
                  {t.role && <div className="text-xs text-[#F5EFE0]/50">{t.role}</div>}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
